// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
var ___CSS_LOADER_ICSS_IMPORT_1___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/_utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
exports.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
exports.push([module.id, "._6XCeEScQx{position:absolute}@media screen and (-ms-high-contrast: active){._6XCeEScQx{border:1px solid windowText;box-sizing:border-box}}._6q82fHh2x{border-radius:6px;box-shadow:0 12px 32px 0 rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3)}._2zzZGHGyx{position:fixed;top:0;left:0;width:100%;height:100vh;min-height:100%;z-index:4;background-color:var(--dark-backdrop)}._2zzZGHGyx._4xXLb9Zhx{pointer-events:none;background-color:transparent}._2zzZGHGyx._4xXLb9Zhx>*{pointer-events:auto}@media (max-height: 800px){._2zzZGHGyx{overflow:auto}}._6XCeEScQx,._2zzZGHGyx{display:none !important}._6XCeEScQx._522aKCiPx,._6XCeEScQx._4TluzQuQx,._2zzZGHGyx._522aKCiPx,._2zzZGHGyx._4TluzQuQx{display:block !important}._2zzZGHGyx._522aKCiPx>._6XCeEScQx,._2zzZGHGyx._4TluzQuQx>._6XCeEScQx{display:block !important}._3PlAExp9x,.FWhQtOPcx{}._6NncTB7Ix{opacity:0;transition-property:opacity}._6NncTB7Ix._3PlAExp9x{opacity:1}._6NncTB7Ix.FWhQtOPcx{opacity:0}._6NncTB7Ix._522aKCiPx{opacity:1}._6NncTB7Ix._6TKfXdkFx{opacity:0}.ZFRigQsDx{transform:translateX(-100%);transition-property:transform}.ZFRigQsDx._3PlAExp9x{transform:translateX(0)}.ZFRigQsDx._3PlAExp9x{transform:translateX(-100%)}.ZFRigQsDx._522aKCiPx{transform:translateX(0)}.ZFRigQsDx._3jsDymvVx{transform:translateX(-100%)}._7d1bAD6bx{transition-property:transform, opacity}._7d1bAD6bx._3PlAExp9x{transform:translateX(-5px)}._7d1bAD6bx._3PlAExp9x{opacity:1}._7d1bAD6bx.FWhQtOPcx{transform:translateX(-5px);opacity:0}._7d1bAD6bx._522aKCiPx{transform:translateX(0);opacity:1}._7d1bAD6bx._1XhGhOe9x{transform:translateX(-5px);opacity:0}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"overlay": "_6XCeEScQx",
	"overlay-standard": "_6q82fHh2x _6XCeEScQx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["white-overlay"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["reset"] + "",
	"overlayStandard": "_6q82fHh2x _6XCeEScQx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["white-overlay"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["reset"] + "",
	"backdrop": "_2zzZGHGyx",
	"transparent": "_4xXLb9Zhx",
	"visible": "_522aKCiPx",
	"animating": "_4TluzQuQx",
	"animating-in": "_3PlAExp9x _4TluzQuQx",
	"animatingIn": "_3PlAExp9x _4TluzQuQx",
	"animating-out": "FWhQtOPcx _4TluzQuQx",
	"animatingOut": "FWhQtOPcx _4TluzQuQx",
	"fade": "_6NncTB7Ix",
	"fade-start": "_6TKfXdkFx",
	"fadeStart": "_6TKfXdkFx",
	"slideright": "ZFRigQsDx",
	"slideright-start": "_3jsDymvVx",
	"sliderightStart": "_3jsDymvVx",
	"slightright": "_7d1bAD6bx",
	"slightright-start": "_1XhGhOe9x",
	"slightrightStart": "_1XhGhOe9x"
};
module.exports = exports;
